const mEditionMapMessagesCreate = {
  mEditionMapMessagesCreate: {
    actions: {
      sendComments: 'Enviar Comentario',
      sendingComments: 'Enviando Comentario',
      sendingQuestions: 'Enviando Respuesta',
      sendQuestions: 'Enviar Respuesta'
    },

    placeholder: {
      writeAnswer: 'Escribir respuesta ...',
      writeComment: 'Escribir comentario ...'
    }
  }
}

export default mEditionMapMessagesCreate
